import React from "react";

const Loading = () => {
  return (
    <div className="flex h-screen items-center justify-center ">
      <div className="w-20 h-20 border-b-2 border-gray-900 rounded-full animate-spin"></div>
    </div>
  );
};

export default Loading;
